import { Box, Button, Grid, Input, Stack, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form'
import { DndContainer } from './components'
import { styles } from './styles'
import type { UploadFilesProps } from './types'
import { Opacity } from '@mui/icons-material'

export const UploadFiles = (props: UploadFilesProps) => {
  const {
    styles: customStyles,
    name,
    label = 'Перетащите файлы или выберите на компьютере',
    setNewFiles,
    errorText,
  } = props

  const files: Array<File> = useWatch({
    name: 'files',
    defaultValue: [],
  })

  const { setValue } = useFormContext()
  const { control } = useFormContext()
  const { append } = useFieldArray({
    control,
    name,
  })

  const onFileDrop = useCallback((files: File[]) => {
    if (!files) return

    const allowedFileTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      // 'image/jpg',
      // 'image/jpeg',
      // 'image/png',
      // 'image/tiff',
      // 'image/bmp',
    ]

    const maxFileSize = 5 * 1024 * 1024 // 5 MB

    const filteredFiles = files.filter((file) => {
      const isTypeAllowed = allowedFileTypes.includes(file.type)
      console.log('file', file.type)
      // const isSizeAllowed = file.size <= maxFileSize
      return isTypeAllowed // && isSizeAllowed
    })

    if (filteredFiles.length > 0) {
      append(Array.from(filteredFiles))
      setNewFiles(filteredFiles)
    } else {
      console.error('Недопустимый тип файла. Выберите файл XLSX.')
      alert('Недопустимый тип файла. Выберите файл XLSX.')
    }
  }, [])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null
    if (!file) {
      return
    }
    onFileDrop([file])
  }

  const deletedFiles = useCallback(() => {
    const filterArray = Array.isArray(files)
    setValue('files', [])
  }, [files])

  const deleteFile = useCallback(
    (index: number) => {
      const arr = files
      arr.splice(index, 1)
      setValue('files', arr)
    },
    [files]
  )

  return (
    <Box
      sx={{
        ...styles.root,
        ...customStyles,
        ...{
          color: errorText ? 'red' : '#000000DE',
        },
      }}
    >
      <DndContainer onDrop={onFileDrop}>
        <Box className={'uploadFiles__drop-zone'}>
          <Typography mb={2} fontWeight={500}>
            {errorText !== undefined ? errorText : label}
          </Typography>
          <Button
            component="label"
            className={'uploadFiles__trigger-btn'}
            variant={'outlined'}
          >
            Добавить файл
            <Input
              onChange={onChange}
              className={'uploadFiles__upload-input'}
              type="file"
              inputProps={{ accept: '.xlsx' }}
            />
          </Button>
          {Array.isArray(files) && !!files.length && (
            <Grid
              spacing={1.5}
              container
              style={{
                marginTop: '16px',
                gap: '8px',
              }}
            >
              {files?.map((item, index) => (
                <Box
                  key={index.toString()}
                  style={{
                    width: '100%',
                    marginLeft: '12px',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    borderRadius: '8px',
                    padding: '8px',
                    overflow: 'hidden',
                  }}
                >
                  <Stack
                    style={{
                      flexDirection: 'row',
                      gap: '8px',
                    }}
                  >
                    <Box
                      style={{
                        minWidth: '30px',
                        minHeight: '30px',
                        maxWidth: '30px',
                        maxHeight: '30px',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteFile(index)}
                    >
                      <div
                        style={{
                          transform: 'scale(70%)',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.998047 1L12.998 13M12.998 1L0.998047 13"
                            stroke="white"
                            strokeWidth="4"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                    </Box>
                    <Stack
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <div
                        style={{
                          color: 'white',
                          fontSize: '14px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {item.name}
                      </div>
                      <div
                        style={{
                          color: '#BBB',
                          fontSize: '10px',
                          marginTop: '-4px',
                          marginRight: 'auto',
                        }}
                      >
                        {Math.trunc(item.size / 1024)}KB
                      </div>
                    </Stack>
                  </Stack>
                </Box>
                // <Grid key={index.toString()} item sm={4}>
                //   <PreviewFile file={item}>
                //     <Checkbox
                //       checked={selected.includes(index)}
                //       onChange={() => checkboxHandle(index)}
                //       size={'small'}
                //       color={'primary'}
                //     />
                //   </PreviewFile>
                // </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </DndContainer>
    </Box>
  )
}
